import axios from 'axios'
import { LISTAR_CONTROLE_EMISSAO_BPE_USUARIO } from '../types'
import { URL } from '../../util/ambienteActions';

export default function listarControleEmissaoBpeUsuario (empresaId) {
  const url = `${URL}/controle-emissao-bpe-usuario/empresa/${empresaId}`;

  return dispatch => axios.get(url).then(
      response => {
        dispatch({
          type: LISTAR_CONTROLE_EMISSAO_BPE_USUARIO,
          payload: response
        });
        return { payload: response };
      }
  );
}

